import React from 'react';
import styled, { ThemeConsumer, css } from 'styled-components';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import Svg from 'app/components/Svg';
import { textTransform } from 'utils';

const propTypes = {
  children: PropTypes.element.isRequired,
  close: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  isSmall: PropTypes.bool,
  isMiddleWidth: PropTypes.bool,
  closeButton: PropTypes.bool,
  isBoxMenu: PropTypes.bool,
};

const defaultProps = {
  title: '',
  isSmall: false,
  isMiddleWidth: false,
  isOpen: false,
  closeButton: true,
  shouldCloseOnOverlayClick: true,
};


// padding: 7px 46px 7px ${({ theme }) => theme.indent.l};
const Title = styled.div`
position: relative;
border-bottom: ${({ theme }) => theme.color.borderDark} solid 1px;
${props =>
    props.boxMenu
      ? css`
      color: ${({ theme }) => theme.color.textPrimary};      
      text-transform: none;
      text-align:start;
      font-weight: 500;
      font-size: 18px;
      padding: 12px 16px;
      `
      : css`
      color: ${({ theme }) => theme.color.accent};
      text-transform: ${textTransform};
      font-size: 2rem;
      font-weight: 700;
      padding: 7px 46px 7px ${({ theme }) => theme.indent.l};
      `}
`;

const CloseBtn = styled.button.attrs({
  type: 'button'
})`
  padding: 10px;
  position: absolute;
  top: 0;
  right: 0;

  & > .svg-close {
    display: block;
    fill: ${({ theme }) => theme.color.textPrimary};
    width: 24px;
    height: 24px;
    transition: opacity 0.2s ease-out;
    opacity: 0.8;
    backface-visibility: hidden;
  }

  &:hover > .svg-close {
    opacity: 1;
  }
`;

const Content = styled.div`
  label {
    text-align: left;
  }

  ${props =>
    props.small
      ? css`
          padding: 24px 16px;
        `
      :
      props.boxMenu ? css`
          // padding: 20px 32px 0px;
          margin: 20px auto 0px;
          max-width: 528px;
        `: css`
        padding: 24px 16px 48px;
      `
  }

  ${props =>
    props.middleWidth &&
    css`
      text-align: left;
    `}

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    padding: 16px 16px 24px;
  }
`;

const Modal = ({ children, title, close, isOpen, isSmall, isMiddleWidth, closeButton, isBoxMenu, shouldCloseOnOverlayClick }) => (
  <ThemeConsumer>
    {theme => {
      const styles = {
        overlay: {
          minWidth: '320px',
          padding: '0 10px',
          zIndex: 12,
          overflowY: 'auto',
          backgroundColor: theme.color.rgbaBlack(0.5),
          textAlign: 'center'
        },
        content: {
          display: 'inline-block',
          verticalAlign: 'middle',
          width: '100%',
          maxWidth: isBoxMenu ? 592 : isMiddleWidth ? 640 : 480,
          margin: '30px 0',
          padding: 0,
          position: 'relative',
          top: 'auto',
          left: 'auto',
          bottom: 'auto',
          right: 'auto',
          borderRadius: theme.indent.s,
          border: 0,
          boxShadow: `0 3px 16px 0 ${theme.color.rgbaBlack(0.5)}`,
          backgroundColor: theme.color.bgPopup
        }
      };
      return (
        <ReactModal
          isOpen={isOpen}
          style={styles}
          onRequestClose={close}
          shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        >
          <Title boxMenu={isBoxMenu}>
            {title}

            {
              // added due to redirect into bonus-card page from bonus recharge modal added successful.
              close ?
                (
                  closeButton && <CloseBtn onClick={close}>
                    <Svg id="close" />
                  </CloseBtn>
                )
                :
                null
            }
          </Title>

          <Content boxMenu={isBoxMenu} small={isSmall} middleWidth={isMiddleWidth}>
            {children}
          </Content>
        </ReactModal>
      );
    }}
  </ThemeConsumer>
);

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
export default React.memo(Modal);
